/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_PositioningInputs */

const en_funnel_sq_positioning = /** @type {(inputs: Funnel_Sq_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening is the [#1] reader purpose-built for students and researchers.`)
};

const es_funnel_sq_positioning = /** @type {(inputs: Funnel_Sq_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening es el lector [n.º 1] creado específicamente para estudiantes e investigadores.`)
};

/**
* | output |
* | --- |
* | "Listening is the [#1] reader purpose-built for students and researchers." |
*
* @param {Funnel_Sq_PositioningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_positioning = /** @type {((inputs?: Funnel_Sq_PositioningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_PositioningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_positioning(inputs)
	return en_funnel_sq_positioning(inputs)
});